import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-previous-surgery-uc',
    templateUrl: './bar-chart-stable-unstable-previous-surgery-uc.component.html',
    styleUrls: ['./bar-chart-stable-unstable-previous-surgery-uc.component.css']
})

export class BarChartStableUnstablePreviousSurgeryUCComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  recidiva = [];
  // other arrays
  stabiliRecidivaNoInterventi = 0;
  stabiliRemissioneNoInterventi = 0;
  instabiliMiglRecidivaNoInterventi = 0;
  instabiliPegRecidivaNoInterventi = 0;
  instabiliMiglRemissioneNoInterventi = 0;
  instabiliPegRemissioneNoInterventi = 0;
  
  stabiliRecidivaInterventi = 0;
  stabiliRemissioneInterventi = 0;
  instabiliMiglRecidivaInterventi = 0;
  instabiliPegRecidivaInterventi = 0;
  instabiliMiglRemissioneInterventi = 0;
  instabiliPegRemissioneInterventi = 0;
  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableUCPreviousSurgery: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['NO PRECEDENTI CHIRURGICI-STABILI','NO PRECEDENTI CHIRURGICI-IN MIGLIORAMENTO','NO PRECEDENTI CHIRURGICI-IN PEGGIORAMENTO',
  'PRECEDENTI CHIRURGICI-STABILI','PRECEDENTI CHIRURGICI-IN MIGLIORAMENTO','PRECEDENTI CHIRURGICI-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.recidiva,
      barThickness: 20,
      backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
      hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
      label: 'RECIDIVA',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
      data: this.remissione,
      barThickness: 20,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrievePreviousSurgeryStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrievePreviousSurgeryStableAndUnstable(){
    this.subscription = this.doctorService.getUCStableAndUnstablePreviousSurgery().subscribe( data => {
      let keys = Object.keys(data);
      //console.log("Keys: " + keys);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissioneNoInterventi'){
          this.stabiliRemissioneNoInterventi = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaInterventi'){
          this.instabiliMiglRecidivaInterventi = values[i];
        }
        else if (key === 'StabiliRemissioneInterventi'){
          this.stabiliRemissioneInterventi = values[i];
        }
        else if (key === 'InstabiliPegRecidivaInterventi'){
          this.instabiliPegRecidivaInterventi = values[i];
        }
        else if (key === 'InstabiliPegRemissioneInterventi'){
          this.instabiliPegRemissioneInterventi = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneInterventi'){
          this.instabiliMiglRemissioneInterventi = values[i];
        }
        else if (key === 'InstabiliPegRemissioneNoInterventi'){
          this.instabiliPegRemissioneNoInterventi = values[i];
        }
        else if (key === 'InstabiliPegRecidivaNoInterventi'){
          this.instabiliPegRecidivaNoInterventi = values[i];
        }
        else if (key === 'StabiliRecidivaNoInterventi'){
          this.stabiliRecidivaNoInterventi = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneNoInterventi'){
          this.instabiliMiglRemissioneNoInterventi = values[i];
        }
        else if (key === 'StabiliRecidivaInterventi'){
          this.stabiliRecidivaInterventi = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaNoInterventi'){
          this.instabiliMiglRecidivaNoInterventi = values[i];
        }
      }
      
      // riempio il vettore della categoria 'recidiva' in ordine stabili, miglioramento e peggioramento
      this.recidiva.push(this.stabiliRecidivaNoInterventi);
      this.recidiva.push(this.instabiliMiglRecidivaNoInterventi);
      this.recidiva.push(this.instabiliPegRecidivaNoInterventi);
      this.recidiva.push(this.stabiliRecidivaInterventi);
      this.recidiva.push(this.instabiliMiglRecidivaInterventi);
      this.recidiva.push(this.instabiliPegRecidivaInterventi);
      console.log("Recidiva chirurgici: " + this.recidiva);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissioneNoInterventi);
      this.remissione.push(this.instabiliMiglRemissioneNoInterventi);
      this.remissione.push(this.instabiliPegRemissioneNoInterventi);
      this.remissione.push(this.stabiliRemissioneInterventi);
      this.remissione.push(this.instabiliMiglRemissioneInterventi);
      this.remissione.push(this.instabiliPegRemissioneInterventi);
      console.log("Remissione chirurgici: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableUCPreviousSurgery') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableUCPreviousSurgery = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableUCPreviousSurgery.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableUCPreviousSurgery.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA' ||
              this.myChartStableUnstableUCPreviousSurgery.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'RECIDIVA' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}